import gql from 'graphql-tag';

export const dokkioUserCapabilitiesFragment = gql`
  fragment dokkioUserCapabilitiesFragment on DokkioUserCapabilities {
    dokkioClass
    canEditDokkioGroups
    canDelete
  }
`;
export default dokkioUserCapabilitiesFragment;
